module.exports = __webpack_public_path__ + "fonts/Didot-Italic.50fdb00b.ttf";